import { render, staticRenderFns } from "./discountList.vue?vue&type=template&id=07b99b1c&"
import script from "./discountList.vue?vue&type=script&lang=js&"
export * from "./discountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports